import { themeColors } from "../../themeColors";
/**
 * @file  src\mobile\pages\AccountSettings.js
 * @brief  This file is responsible for account settings ui
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { pageURLs } from "@/constants";
import { fetchUserDetails } from "../../actions/userprofile";
import { getLocalStorage } from "../../helpers/common";
import {
  NOT_FREE_OR_MEMBER_PERIOD,
  USER_INFO_KEY,
} from "../../constants/common";
import ProfileAgentUserPremium from "./ProfileAgentUserPremium";
import ProfileNormalUser from "./ProfileNormalUser";
import TopHeader from "../components/common/TopHeader";
import { usePremium } from "@/hooks";
import BackLinkButton from "../components/BackLinkButton";

const AccountSettings = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );
  const userId = _.get(sessionData, "userInfo.userId", "");
  const [userDetails, setUserDetails] = useState(null);
  const [upComingPlanDetails, setupComingPlanDetails] = useState(null);
  const userType = userDetails?.UserTypeId;
  const [reload, setReload] = useState(0);

  const { shouldToggleColor } = usePremium();

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserDetails());
    }
  }, [reload]);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
      if (userDetailsFromStore?.length > 1) {
        setupComingPlanDetails(
          userDetailsFromStore[userDetailsFromStore?.length - 1],
        );
      } else {
        setupComingPlanDetails(null);
      }
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  const updateReloadParam = () => {
    setReload(reload + 1);
  };

  return (
    <>
      <div className="gitcha-main-wrapper pb-0">
        <div className="content-wrapper h-100">
          <TopHeader
            variant={"threeComp"}
            outerClassname="bg-white"
            topClassName="w-100 flex-column top-three-comp-headerborder"
            bottomClassName="w-100"
          >
            <BackLinkButton
              shouldToggleColor={shouldToggleColor}
              to={pageURLs.mobileSettings}
            />
            <div className={shouldToggleColor ? "heading-premium" : "heading"}>
              Account
            </div>
            <div className="p-0 toplinks-mobile">
              <div className="topbar-links notif-delete-btn d-none"></div>
            </div>
          </TopHeader>
          {userType === 1 ? (
            <ProfileNormalUser
              userDetails={userDetails}
              updateReloadParam={updateReloadParam}
              upComingPlanDetails={upComingPlanDetails}
            />
          ) : userType === 2 &&
            userDetails?.period > NOT_FREE_OR_MEMBER_PERIOD ? (
            <ProfileAgentUserPremium
              userDetails={userDetails}
              updateReloadParam={updateReloadParam}
              upComingPlanDetails={upComingPlanDetails}
            />
          ) : (
            <ProfileAgentUserPremium
              userDetails={userDetails}
              updateReloadParam={updateReloadParam}
              upComingPlanDetails={upComingPlanDetails}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AccountSettings;
